import React, { useEffect, useState, useCallback } from "react"
import { Container, Form, Modal } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import { Table, Row, Col, Card, CardBody } from "reactstrap"
import roleImg from "../../../assets/images/role-3.avif"

// common component 
import Loader from "../../../pages/Separate/Loader"
import Swal from "sweetalert2"
import AccessDeniedPopup from "../../../routes/AccessDeniedPopup"
import NewPagination from "../../../components/Common/Newpagination"
import { fetchNodeData, FetchNodeDeleteData, FetchNodePostData, FetchNodePutData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"

function TableContainer({ columns, data, setAccessDenied, isLoading, onAddClick }) {
  const [fixedHeader, setFixedHeader] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)

  document.addEventListener("scroll", () => {
    // const scrollThreshold = window.innerHeight * 0.25;
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  const navigate = useNavigate()

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => setPageSize(50), [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerHeight * 0.25;
      const scrollY = window.scrollY;

      setFixedContent(scrollY > scrollThreshold);
      setFixedHeader(scrollY > 165);
    };

    window.addEventListener("scroll", handleScroll);
    // Initial call to set state correctly if page starts scrolled
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array means this runs once on mount

  const [name_modal, setNameModal] = useState(false)
  const [action_modal, setActionModal] = useState(false)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_center() {
    setNameModal(false)
    removeBodyCss()
  }
  // const onAddPermission = async id => {
  //   setLoading(true)
  //   const formData = new FormData()
  //   formData.append("user_id", localStorage.getItem("auth_id"))
  //   formData.append("module_id", 69)
  //   try {
  //     await axios({
  //       method: "post",
  //       url: `${configure.apiUrl}/earth_permission`,
  //       data: formData,
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "multipart/form-data",
  //       },
  //     }).then(res => {
  //       if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
  //         navigate(`${configure.appUrl}addroles`)
  //       } else {
  //         setAccessDenied(true)
  //       }
  //       setLoading(false)
  //     })
  //   } catch (error) {
  //     console.log(error)
  //     setLoading(false)
  //   }
  // }

  return (
    <div id="Roles">
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          //to={`${configure.appUrl}addroles`}
          className="btn btn-save  fix-btn btn-label pe-0"
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Roles</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className=" form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              // to={`${configure.appUrl}addroles`}
              //onClick={onAddPermission}
              onClick={onAddClick}
              className=" btn btn-save btn-label"
            >
              {" "}
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Add HSN
            </button>
            <button
              onClick={() => navigate(-1)}
              className=" btn ms-md-2 btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <div className="row">
        <div className="col-md-4 d-flex justify-content-center">
          <div className={`${fixedHeader ? "rolesIndexImg" : ""}`}>
            <img src={roleImg} alt="roleImg" className="w-100" />
          </div>
        </div>
        <div className="col-md-8 pt-4">
          <Table
            id="roles-table"
            className="table table-bordered shadow-sm"
            {...getTableProps()}
          >
            <thead className={`${(fixedHeader && page.length >= 10) ? "fix-header-roles-table" : ""} fix-roles-table`}>
              {headerGroups.map((headerGroup, i) => (
                <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      className={`t-head-${index + 1} ${column.className} customShortIcon`}
                      key={index}
                      {...column.getHeaderProps()}
                    >
                      {column.render("Header")}
                      {column.isInfoIcon ? (
                        <a
                          onClick={() => {
                            // if(column)
                            if (column.Header == "Role Name") {
                              setNameModal(true)
                            } else if (column.Header == "Action") {
                              setActionModal(true)
                            }
                          }}
                        >
                          <i
                            title="info"
                            className="bx bx-info-circle ms-1 info-icon"
                          ></i>
                        </a>
                      ) : null}

                      {column.isShortIcon && (
                        <span
                          onClick={(e) =>
                            column.getSortByToggleProps().onClick(e)
                          }
                          className="ms-2 cursor-pointer"
                        >
                          <i
                            title="Ascending"
                            className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
                              ? "text-dark"
                              : ""
                              }`}
                          ></i>
                          <i
                            title="Descending"
                            className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                              ? "text-dark"
                              : ""
                              }`}
                          ></i>
                        </span>
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {isLoading ? (
                <tr>
                  <td colSpan={columns.length} className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="text-center py-5">
                    <div className="mt-3">
                      <i className="bx bx-file-blank display-4 text-muted"></i>
                      <p className="mt-2">No HSN Records Found</p>
                    </div>
                  </td>
                </tr>
              ) : (
                page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr className="row-hover" {...row.getRowProps()} key={row.id || i}>
                      {row.cells.map((cell, index) => (
                        <td
                          className={cell.column.className}
                          key={index}
                          {...cell.getCellProps()}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const HsnIndex = () => {
  //meta title
  const [data, setDatas] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [modal_Access, setAccessDenied] = useState(false)

  const [modal_center, setmodal_center] = useState(false);
  const [isEdit, setIsEdit] = useState(false); // To toggle between Add and Edit mode

  // Form States
  const [hsnName, setHsnName] = useState(""); // Maps to 'Number' in your table
  const [hsnType, setHsnType] = useState(""); // Maps to 'Title' in your table
  const [selectedId, setSelectedId] = useState(null);

  // Open Modal for Adding
  const handleAddClick = () => {
    setIsEdit(false);
    setHsnName("");
    setHsnType("");
    setmodal_center(true);
  };

  // Open Modal for Editing
  const handleEdit = useCallback((rowData) => {
    setIsEdit(true);
    setSelectedId(rowData.id);
    setHsnName(rowData.number);
    setHsnType(rowData.title);
    setmodal_center(true);
  }, []);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this HSN",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          await FetchNodeDeleteData(setLoading, `/hsn`, id)

          Swal.fire("Deleted!", "HSN deleted successfully.", "success");

          fetchHsn();   // 🔥 refresh table
        } catch (error) {
          console.log(error);
          Swal.fire("Error", "Something went wrong", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      if (isEdit) {

        await FetchNodePutData(setLoading, "/hsn", selectedId, {
          number: hsnName,
          title: hsnType,
        })

        Swal.fire("Updated!", "HSN updated successfully.", "success");
      } else {
        await FetchNodePostData(setLoading, "/hsn",
          secureLocalStorage.getItem("auth_token"),
          {
            number: hsnName,
            title: hsnType,
          })

        Swal.fire("Created!", "HSN added successfully.", "success");
      }

      fetchHsn();        // 🔥 refresh table
      setmodal_center(false);

    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };


  const fetchHsn = async () => {
    try {
      setLoading(true);
      const response = await fetchNodeData(setLoading, "hsn", secureLocalStorage.getItem("auth_token"))

      if (response.success) {
        setDatas(response.data);
      } else {
        setDatas([]);
      }
    } catch (error) {
      console.log(error);
      setDatas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHsn()

    document.title = "HSN  | Zithas Crm"

  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isShortIcon: true,
        className: "text-center categ-id"
      },
      {
        Header: "Number",
        accessor: "number",
        isShortIcon: true,
        className: "categ-name"
      },
      {
        Header: "Title",
        accessor: "title",
        isShortIcon: true,
        className: "categ-type"
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center categ-action",
        Cell: cellProps => {
          return (
            <div>
              <button
                onClick={() => handleEdit(cellProps.row.original)} // Trigger Edit
                className="btn action-btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </button>

              <button
                onClick={() => handleDelete(cellProps.row.original.id)}
                className="btn btn-sm action-btn btn-danger"
              >
                <i className="fas fa-trash-alt"></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loader />}
        <Container fluid>
          <Breadcrumbs
            title={"Dashboard"}
            breadcrumbItem={"HSN"}
          />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setAccessDenied={setAccessDenied}
                      isLoading={isLoading}
                      onAddClick={handleAddClick}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Access Denied */}

      {/*add/edit modal*/}
      <Modal
        isOpen={modal_center}
        toggle={() => setmodal_center(!modal_center)}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">{isEdit ? "Update HSN" : "Add HSN"}</h5>
          <button
            type="button"
            onClick={() => setmodal_center(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleFormSubmit}>
            <Row>
              <div className="col-6">
                <label>Number</label>
                <input
                  type="text"
                  placeholder="Enter Number"
                  className="form-control"
                  value={hsnName}
                  onChange={e => setHsnName(e.target.value)}
                  required
                />
              </div>
              <div className="col-6">
                <label>Title</label>
                <input
                  type="text"
                  placeholder="Enter Title"
                  className="form-control"
                  value={hsnType}
                  onChange={e => setHsnType(e.target.value)}
                  required
                />
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button type="submit" className="btn btn-save btn-label">
                <i className="fas fa-save me-2 label-icon"></i>
                {isEdit ? "Update" : "Submit"}
              </button>
              <button
                type="button"
                onClick={() => setmodal_center(false)}
                className="btn btn-red btn-label ms-2"
              >
                <i className="dripicons-cross me-2 label-icon"></i>
                Cancel
              </button>
            </div>
          </Form>
        </div>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default HsnIndex
